// import React, { useContext, useState } from 'react';
// import { ShopContext } from '../context/ShopContext';
// import { Link } from 'react-router-dom';

// const ProductItem = ({ id, image, name, price ,op}) => {
//   const { currency } = useContext(ShopContext);
//   const [hovered, setHovered] = useState(false);

//   // Handle hover state
//   const handleMouseEnter = () => setHovered(true);
//   const handleMouseLeave = () => setHovered(false);

//   return (
//     <Link
//       onClick={() => scrollTo(0, 0)}
//       className="text-gray-700 cursor-pointer block"
//       to={`/product/${id}`}
//     >
//       <div
//         className="overflow-hidden rounded-lg shadow-md bg-white"
//         onMouseEnter={handleMouseEnter}
//         onMouseLeave={handleMouseLeave}
//       >
//         {/* Container for 4:5 aspect ratio */}
//         <div className="relative w-full" style={{ paddingTop: '125%' }}>
//           <img
//             className="transition-transform duration-300 ease-in-out object-cover absolute top-0 left-0 w-full h-full"
//             src={hovered ? image[1] : image[0]} // Show second image on hover
//             alt={name}
//             importance="high"
//           />
//         </div>
//       </div>
//       <div className="text-center mt-3">
//         <p className="pt-1 pb-1 text-sm font-medium text-gray-800">{name}</p>
//         <div className="flex items-center justify-center space-x-2">
//           <p className="text-sm font-semibold text-gray-900">
//             {currency}
//             {price}
//           </p>
//           <p className="text-sm font-semibold text-gray-500 line-through">
//             {currency}
//             {op}
//           </p>
//         </div>
//       </div>
//     </Link>
//   );
// };

// export default ProductItem;


// import React, { useContext, useState } from 'react';
// import { ShopContext } from '../context/ShopContext';
// import { Link } from 'react-router-dom';

// const ProductItem = ({ id, image, name, price, op }) => {
//   const { currency } = useContext(ShopContext);
//   const [hovered, setHovered] = useState(false);

//   // Handle hover state
//   const handleMouseEnter = () => setHovered(true);
//   const handleMouseLeave = () => setHovered(false);

//   // Convert name to slug with underscores
//   const slug = name.replace(/\s+/g, "_").toLowerCase();

//   return (
//     <Link
//       onClick={() => scrollTo(0, 0)}
//       className="text-gray-700 cursor-pointer block"
//       to={`/product/${slug}`}  // 👈 Now includes name slug + ID
//     >
//       <div
//         className="overflow-hidden rounded-lg shadow-md bg-white"
//         onMouseEnter={handleMouseEnter}
//         onMouseLeave={handleMouseLeave}
//       >
//         {/* Container for 4:5 aspect ratio */}
//         <div className="relative w-full" style={{ paddingTop: '125%' }}>
//           <img
//             className="transition-transform duration-300 ease-in-out object-cover absolute top-0 left-0 w-full h-full"
//             src={hovered ? image[1] : image[0]} // Show second image on hover
//             alt={name}
//             importance="high"
//           />
//         </div>
//       </div>
//       <div className="text-center mt-3">
//         <p className="pt-1 pb-1 text-sm font-medium text-gray-800">{name}</p>
//         <div className="flex items-center justify-center space-x-2">
//           <p className="text-sm font-semibold text-gray-900">
//             {currency}
//             {price}
//           </p>
//           <p className="text-sm font-semibold text-gray-500 line-through">
//             {currency}
//             {op}
//           </p>
//         </div>
//       </div>
//     </Link>
//   );
// };

// export default ProductItem;


import React, { useContext, useState } from 'react';
import { ShopContext } from '../context/ShopContext';
import { Link } from 'react-router-dom';

const ProductItem = ({ id, image, name, price, op }) => {
  const { currency } = useContext(ShopContext);
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => setHovered(true);
  const handleMouseLeave = () => setHovered(false);
  const slug = name.replace(/\s+/g, "_").toLowerCase();

  const optimizedImage = (url, width, height) =>
    `${url}?w=${width}&h=${height}&c_fill&f_auto&q_auto`;

  return (
    <Link
      // onClick={() => scrollTo(0, 0)}
      className="text-gray-700 cursor-pointer block"
      to={`/product/${slug}`}
    >
      <div
        className="overflow-hidden rounded-lg shadow-md bg-white"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="relative w-full" style={{ paddingTop: '125%' }}>
          <img
            className="transition-transform duration-300 ease-in-out object-cover absolute top-0 left-0 w-full h-full"
            src={hovered ? optimizedImage(image[1], 300, 375) : optimizedImage(image[0], 300, 375)}
            srcSet={hovered 
              ? `${optimizedImage(image[1],150,188)} 150w, ${optimizedImage(image[1],300,375)} 300w, ${optimizedImage(image[1],600,750)} 600w`
              : `${optimizedImage(image[0],150,188)} 150w, ${optimizedImage(image[0],300,375)} 300w, ${optimizedImage(image[0],600,750)} 600w`
            }
            sizes="(max-width: 640px) 150px, (max-width: 1024px) 300px, 300px"
            alt={name}
            loading="lazy"
          />
        </div>
      </div>
      <div className="text-center mt-3">
        <p className="pt-1 pb-1 text-sm font-medium text-gray-800">{name}</p>
        <div className="flex items-center justify-center space-x-2">
          <p className="text-sm font-semibold text-gray-900">
            {currency}{price}
          </p>
          <p className="text-sm font-semibold text-gray-500 line-through">
            {currency}{op}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default ProductItem;
